import { useContext, useState } from "react";
import { OnboardingContext } from "../context/OnboardingContext";

export default function Billing() {
  const { sessionId, adminEmail, inviteToken, setCurrentStep } = useContext(OnboardingContext);

  const [paymentMethodType, setPaymentMethodType] = useState("card");

  async function submit() {
    const res = await fetch("/api/admin-onboarding/create-stripe-session", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: sessionId,
        billing_contact_email: adminEmail,
        payment_method_type: paymentMethodType,
        invite_token: inviteToken
      })
    });

    const data = await res.json();

    if (data.checkout_url) {
      window.location.href = data.checkout_url;
    }
  }


  return (
    <div>
      <h2>Billing Setup</h2>
      <p>Please choose how you would like to set up your payment method.</p>

      <div className="radio-group">

        <label className="radio-option">
          <input
            type="radio"
            value="card"
            checked={paymentMethodType === "card"}
            onChange={() => setPaymentMethodType("card")}
          />
          <span>Credit / Debit Card</span>
        </label>

        <label className="radio-option">
          <input
            type="radio"
            value="bank"
            checked={paymentMethodType === "bank"}
            onChange={() => setPaymentMethodType("bank")}
          />
          <span>Bank Account (ACH)</span>
        </label>

      </div>

      <button onClick={submit}>Continue</button>
    </div>
  );
}